import {useEffect} from "react";
import {postSubmit} from "@ui-seeker/utils";

import {WEBBACK_V2_API} from "@constants";
import {isLoadingCommonFilters, isSystemBusy} from "@signals";
import {
	isLoadingNumbers, numbersData, isLoadingAuthorized, authorizedData, marketDetailsData, isLoadingMarketDetails, isLoadingMarketPosition, marketPositionAllData,
	topSellersAllData, isLoadingTopSellers
} from "../@signals";


export default function useMarketplacesSearch() {

	useEffect(() => {
		if (!isLoadingTopSellers.value && !isLoadingAuthorized.value && !isLoadingMarketDetails.value && !isLoadingMarketPosition.value && !isLoadingNumbers.value)
			isLoadingCommonFilters.value = false
	}, [isLoadingTopSellers.value, isLoadingAuthorized.value, isLoadingMarketDetails.value, isLoadingMarketPosition.value, isLoadingNumbers.value]);

	const __callAuthorized = values => {
		isLoadingAuthorized.value = true
		postSubmit(`${WEBBACK_V2_API}/marketplaces/authorized`, values).then(({ data }) => {
			authorizedData.value = data
		}).catch(()=> {
			isLoadingCommonFilters.value = false
			isSystemBusy.value = true
		}).finally(() => isLoadingAuthorized.value = false)
	}

	const __callMarketDetails = values => {
		isLoadingMarketDetails.value = true
		postSubmit(`${WEBBACK_V2_API}/marketplaces/market-details`, values).then(({ data }) => {
			marketDetailsData.value = data
		}).catch(()=> {
			isLoadingCommonFilters.value = false
			isSystemBusy.value = true
		}).finally(() => isLoadingMarketDetails.value = false)
	}

	const __callMarketPosition = values => {
		isLoadingMarketPosition.value = true
		postSubmit(`${WEBBACK_V2_API}/marketplaces/market-position`, values).then(res => {
			marketPositionAllData.value = res
		}).catch(()=> {
			isLoadingCommonFilters.value = false
			isSystemBusy.value = true
		}).finally(() => isLoadingMarketPosition.value = false)
	}

	const __callNumbers = values => {
		isLoadingNumbers.value = true
		postSubmit(`${WEBBACK_V2_API}/marketplaces/numbers`, values).then(res => {
			numbersData.value = res
		}).catch(()=> {
			isLoadingCommonFilters.value = false
			isSystemBusy.value = true
		}).finally(() => isLoadingNumbers.value = false)
	}

	const __callTopSellers = values => {
		isLoadingTopSellers.value = true
		postSubmit(`${WEBBACK_V2_API}/marketplaces/top-sellers`, values).then(res => {
			topSellersAllData.value = res
		}).catch(()=> {
			isLoadingCommonFilters.value = false
			isSystemBusy.value = true
		}).finally(() => isLoadingTopSellers.value = false)
	}

	const handleSubmit = values => {
		isSystemBusy.value = false
		__callAuthorized(values)
		__callMarketDetails(values)
		__callNumbers(values)
		__callTopSellers(values)
		__callMarketPosition(values)
	}

	return {
		handleSubmit
	}
}